module.exports = "<hr class=\"separator\">\n<div class=\"footer\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/modal/modal-footer.component.html
// module id = g549
// module chunks = 6